export default __webpack_public_path__ + "static/media/lunch6.2d5416af.png";